import React, { useEffect, useState, useCallback } from 'react';

import { Auth } from 'aws-amplify';
import Axios from 'axios';
import { API_ROUTES } from 'src/config/api';
import { Spinner } from "reactstrap";
import Skeleton from 'react-loading-skeleton'

import 'react-loading-skeleton/dist/skeleton.css'

const PayoutConfiguration = ({ organisation }) => {
  const [loading, setLoading] = useState(true);
  const [changing, setChanging] = useState({
    enabled: false,
    ledgering: false,
    balancing: false,
  });
  const [enabled, setEnabled] = useState({
    enabled: false,
    ledgering: false,
    balancing: false,
  });

  const getPayoutConfiguration = useCallback(async () => {
    const user = await Auth.currentAuthenticatedUser();

    const result = await Axios(
      API_ROUTES.user['organisation:payout-configuration'](organisation.organisation),
      {
        method: 'get',
        headers: { Authorization: `Bearer ${user.signInUserSession.idToken.jwtToken}` },
      }
    );

    setLoading(false)
    setEnabled(result.data.data)
  }, [organisation.organisation]);

  const changeStatus = async (item, status) => {
    setChanging({
      ...changing,
      [item]: true,
    });

    const user = await Auth.currentAuthenticatedUser();

    await Axios.post(
      API_ROUTES.user['organisation:payout-configuration:change'](organisation.organisation),
      JSON.stringify({ item, status }),
      {
        headers: {
          Authorization: `Bearer ${user.signInUserSession.idToken.jwtToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    setChanging({
      ...changing,
      [item]: false,
    });
    setEnabled({
      ...enabled,
      [item]: status,
    });
  }

  useEffect(() => {
    getPayoutConfiguration();
  }, [getPayoutConfiguration]);

  return (

    <div>
      <h3 className="font-extralight uppercase font-mono text-2xl dark:text-white text-violet-900 mt-4 mb-4 border-b border-violet-900 pb-2">
        Payout Configuration
      </h3>

      <div className="pb-4 pt-3">
        {loading === true && (
          <div className='mt-2 mb-2'>
            <Skeleton count={3} height="50px" className="mt-1 mb-1" style={{
              width: '100%',
            }} />
          </div>
        )}

        {loading === false && (
          <React.Fragment>
            <table className="table-auto w-full divide-y divide-gray-200">
              <tbody className='divide-y divide-gray-200'>
                <tr>
                  <td className='pb-4 pr-4'>
                    <strong className='text-purple-900'>Payouts Enabled</strong> <br />Whether payouts should be made to this organisations beneficiaries
                  </td>
                  <td>
                    <span>{changing.enabled && <Spinner size="sm" className="mt-1 mr-3"> </Spinner>}</span>
                    <div className="custom-control custom-switch">
                      <input
                        type="checkbox"
                        className="custom-control-input form-control"
                        checked={enabled.enabled}
                        disabled={changing.enabled}
                        onChange={() => changeStatus('enabled', enabled.enabled !== true)}
                        id={`payouts-switch`}
                      />
                      <label className="custom-control-label" htmlFor={`payouts-switch`} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className='py-4 pr-4'>
                    <strong className='text-purple-900'>Ledgering Enabled</strong> <br />Whether the ledger should be respected when making payouts
                  </td>
                  <td>
                    <span>{changing.ledgering && <Spinner size="sm" className="mt-1 mr-3"> </Spinner>}</span>
                    <div className="custom-control custom-switch">
                      <input
                        type="checkbox"
                        className="custom-control-input form-control"
                        checked={enabled.ledgering}
                        disabled={changing.ledgering}
                        onChange={() => changeStatus('ledgering', enabled.ledgering !== true)}
                        id={`ledgering-switch`}
                      />
                      <label className="custom-control-label" htmlFor={`ledgering-switch`} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className='py-4 pr-4'>
                    <strong className='text-purple-900'>Account Balancing</strong> <br />Balancing off adjustments against ledger balance. <br /><small className="text-red-800">This should only be enabled for brand new accounts, as does not consider manual adjustments, work needs to be done on a per agent level before this can be enabled.</small>
                  </td>
                  <td>
                    <span>{changing.balancing && <Spinner size="sm" className="mt-1 mr-3"> </Spinner>}</span>
                    <div className="custom-control custom-switch">
                      <input
                        type="checkbox"
                        className="custom-control-input form-control"
                        checked={enabled.balancing}
                        disabled={changing.balancing}
                        onChange={() => changeStatus('balancing', enabled.balancing !== true)}
                        id={`balancing-switch`}
                      />
                      <label className="custom-control-label" htmlFor={`balancing-switch`} />
                    </div>
                  </td>
                </tr>

              </tbody>
            </table>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};
export default PayoutConfiguration;
